const translations = {
    boundaryNameFieldPlaceholder: 'Boundary Name'
};

export default translations;
